import { MRT_RowSelectionState } from 'material-react-table';

export type SelectionState = {
    selectedRows: MRT_RowSelectionState;
    allRowsSelected: boolean;
};

export type SelectionAction =
    | { type: 'ROW_TOGGLE'; rowId: string; checked: boolean }
    | { type: 'SELECT_ALL'; checked: boolean; selection: MRT_RowSelectionState }
    | { type: 'RESET' }
    | { type: 'SET_SELECTED_ROWS'; payload: MRT_RowSelectionState }
    | { type: 'SET_ALL_ROWS_SELECTED'; value: boolean };

/**
 * Reducer for row selection state.
 * Updates selectedRows and allRowsSelected atomically so totalSelectedRows stays in sync.
 */
export function selectionReducer(state: SelectionState, action: SelectionAction): SelectionState {
    switch (action.type) {
        case 'ROW_TOGGLE': {
            const stringRowId = String(action.rowId);
            if (state.allRowsSelected && !action.checked) {
                const { [stringRowId]: omitted, ...rest } = state.selectedRows;
                return { allRowsSelected: false, selectedRows: rest };
            }
            if (state.allRowsSelected && action.checked) {
                return {
                    allRowsSelected: true,
                    selectedRows: { ...state.selectedRows, [stringRowId]: true },
                };
            }
            if (action.checked) {
                return {
                    ...state,
                    selectedRows: { ...state.selectedRows, [stringRowId]: true },
                };
            }
            const { [stringRowId]: omitted, ...rest } = state.selectedRows;
            return { ...state, selectedRows: rest };
        }
        case 'SELECT_ALL':
            return action.checked
                ? { allRowsSelected: true, selectedRows: action.selection }
                : { allRowsSelected: false, selectedRows: {} };
        case 'RESET':
            return { allRowsSelected: false, selectedRows: {} };
        case 'SET_SELECTED_ROWS':
            return { ...state, selectedRows: action.payload, allRowsSelected: false };
        case 'SET_ALL_ROWS_SELECTED':
            return { ...state, allRowsSelected: action.value };
        default:
            return state;
    }
}

export const initialState: SelectionState = { selectedRows: {}, allRowsSelected: false };
